import { useState } from "react";
import Button from "../../../common/Button";
import { cancelTransferRequest } from "../../../../lib/fetchApi";
import { useDispatch, useSelector } from "react-redux";
import { notificationActions } from "../../../../store/notifications";
import { caseActions } from "../../../../store/case";

export default function TransferClinicCancel({practiceData,status}) {
    const dispatch = useDispatch()
    const [loading, isLoading] = useState(false)

    const userToken = useSelector(state => state.user.token)
    const activeCase = useSelector(state => state.case.activeCase)


    async function cancelTransferHandler() {
        isLoading(true)
        let reqBody = {
            // case_practice_id: practiceData.id,
            case_practice_id:practiceData.case_practice_transfers.find(item => item.status == status)?.case_practice_id,
            case_practice_transfer_id: practiceData.case_practice_transfers.find(item => item.status == status)?.id
        }

        let cancelTransfer = await cancelTransferRequest(userToken, activeCase.case.id, reqBody, dispatch)
        if (cancelTransfer && cancelTransfer.errorMessage) {
            dispatch(notificationActions.setError(cancelTransfer))     
        } else {            
            dispatch(notificationActions.setError({errorMessage: `Transfer Canceled!`, type: 'success'}))    
            
            let dispatchBody = {
                case_practice_id: practiceData.id,
                item: cancelTransfer
            }   
            dispatch(caseActions.updateTransfersOnPractices(dispatchBody)) 
        }

        isLoading(false)
    }
    return <Button btnStyle={'btn_simple'} title={'Cancel transfer'} click={cancelTransferHandler} isLoading={loading}><i className="ti ti-home-off" style={{color: 'var(--red)'}}></i></Button>
}